<img src="./assets/media/svg/icons/General/Edit-3.svg" placement="bottom" ngbTooltip="Edit" (click)="invokeParentMethod()">
&nbsp;
<span *ngIf="displayRelation"> <img src="./assets/media/svg/icons/General/Hierarchy.svg" placement="bottom" ngbTooltip="Manage Dependency" (click)="invokeRelationMethod()"></span>

